import { Config } from "@crm-in-store/mist-shared-config";
export type Tenant = 'th' | 'ck';
export interface FeatureFlag {
  signUpAvailable: CountryCode[];
}
export const languages = ['en', 'nl', 'de', 'es', 'fr', 'it', 'pl', 'ru', 'cs'] as const;
type ElementType<T extends ReadonlyArray<unknown>> = T extends ReadonlyArray<
  infer ElementType
>
  ? ElementType
  : never;
export type LanguageCode = ElementType<typeof languages>;
export type CountryCode = string;
export interface Country {
  nativeName: string;
  language: Language[];
  name: string;
  code: CountryCode;
}
export interface Language {
  code: LanguageCode | string;
  label: string;
  default?: boolean;
}

export const getCountriesAsync = async (): Promise<Country[]> => {
  const env = Config.get('env');
  const tenant = Config.get('tenant');
  if (!env) throw new Error('Please, set "env" key in shared-config. Example: `Config.set("env", "prd")`');
  if (!tenant) throw new Error('Please, set "tenant" key in shared-config. Example: `Config.set("tenant", "th")`');

  return fetch(`https://api.${env}.crm-in-store.eu.pvh.cloud/v1/${tenant}/countries`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
    .then(response => response.json())
    .then(response => response.data);
}

export const getFeatureFlagsAsync = async (): Promise<FeatureFlag> => {
  const env = Config.get('env');
  const tenant = Config.get('tenant');
  if (!env) throw new Error('Please, set "env" key in shared-config. Example: `Config.set("env", "prd")`');
  if (!tenant) throw new Error('Please, set "tenant" key in shared-config. Example: `Config.set("tenant", "th")`');

  return fetch(`https://api.${env}.crm-in-store.eu.pvh.cloud/v1/${tenant}/features`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
    .then(response => response.json())
    .then(response => response.data);
}

const cacheResponse = <T>(asyncCall: () => Promise<T>): () => Promise<T> => {
  let promise: Promise<T>;

  return () => {
    if (!promise) promise = asyncCall();
    return promise;
  };
}

export const getCountries = cacheResponse(getCountriesAsync);
export const getFeatureFlags = cacheResponse(getFeatureFlagsAsync);
